// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"LeftPanel_contentWrapper__2lbuF"};